import * as React from "react";
import { createComponent } from "@lit/react";
import Component from "../../components/CloseButton/sgds-close-button";
import { register } from "../../utils/ce-registry";

register("sgds-close-button", Component);

export default createComponent({
  react: React,
  tagName: "sgds-close-button",
  elementClass: Component,
  events: {}
});
